import { render, staticRenderFns } from "./OsobaUmanjeniSati.vue?vue&type=template&id=4d8279ac&scoped=true&"
import script from "./OsobaUmanjeniSati.vue?vue&type=script&lang=js&"
export * from "./OsobaUmanjeniSati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8279ac",
  null
  
)

export default component.exports